import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-638b56e7"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("4.8/5")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("2-3h")
const _hoisted_3 = { class: "ion-padding-horizontal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_text = _resolveComponent("ion-text")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", null, [
      _createVNode(_component_ion_img, {
        src: _ctx.getImg(_ctx.story),
        class: "cover"
      }, null, 8, ["src"])
    ]),
    _createElementVNode("p", null, [
      _createVNode(_component_ion_chip, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_icon, { name: "person" }),
          _createVNode(_component_ion_label, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.story.minPlayers) + "-" + _toDisplayString(_ctx.story.maxPlayers), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_chip, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_icon, { name: "star" }),
          _createVNode(_component_ion_label, null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_chip, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_icon, { name: "time" }),
          _createVNode(_component_ion_label, null, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.t("story.synopsis")), 1),
    _createElementVNode("p", null, [
      _createVNode(_component_ion_text, {
        color: "medium",
        class: "description ion-padding-horizontal"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.story.description), 1)
        ]),
        _: 1
      })
    ])
  ]))
}